function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { View } from "../native";
import DataRender from "../DataRender";
import wrapComponent from "../../core/wrapComponent";
import * as R from 'unitx/ramda';
import ElementWrapper from "./ElementWrapper";

function Tree(props) {
  const {
    data,
    renderItem,
    style,
    renderChildren,
    accessor,
    left,
    right
  } = props;
  return /*#__PURE__*/React.createElement(View, {
    style: style
  }, /*#__PURE__*/React.createElement(DataRender, {
    data: data,
    accessor: accessor,
    renderItem: (_ref) => {
      let {
        children,
        level,
        item,
        parentItem,
        accessor: itemAccessor
      } = _ref,
          rest = _objectWithoutProperties(_ref, ["children", "level", "item", "parentItem", "accessor"]);

      return /*#__PURE__*/React.createElement(ElementWrapper, {
        id: item.id,
        key: item.id,
        parentItem: parentItem,
        level: level,
        noChild: R.anyPass([R.pathSatisfies(R.isNil, [...itemAccessor, 'length']), R.pathSatisfies(R.equals(0), [...itemAccessor, 'length'])])(item),
        renderChildren: () => children,
        left: left,
        right: right
      }, renderItem(_objectSpread({
        level,
        item,
        parentItem,
        accessor: itemAccessor
      }, rest)));
    },
    renderChildren: renderChildren
  }));
}

export default wrapComponent(Tree, {});